module.exports = __webpack_public_path__ + "static/media/kuharchek_vining_mosca.5c21796e.jpg";